import { render, staticRenderFns } from "./BindQQ.vue?vue&type=template&id=7af8d8d7&"
import script from "./BindQQ.vue?vue&type=script&lang=js&"
export * from "./BindQQ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports